import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Box } from 'rebass';
import { Input, Divider } from 'semantic-ui-react';
import _ from 'lodash';
import ReactGA from 'react-ga';

import GridList from '../GridList';

const SearchInput = styled(Input)`
  &.ui.input > input {
    border-radius: 0;
    border-width: 0;
    padding-top: 0.4em;
    padding-bottom: 0.4em;
  }
  &.ui.input > input::-webkit-input-placeholder {
    font-weight: 200;
  }
  &.ui[class*='left icon'].input > input {
    padding-left: 1.8em !important;
  }
  &.ui.icon.input > i.icon {
    width: auto;
  }
`;

const defaultSearchFn = (data = { title: '' }, text) => {
  if (!text || text.length === 0) return true;
  const title = data.title || '';
  return title.indexOf(text) >= 0;
};

class SearchableGridList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filteredData: props.data,
      filterText: '',
    };
    this.filteringData = _.debounce(this.filteringData, 700, { maxWait: 1000, trailing: true });
    this.trackSearchTerm = _.debounce(this.trackSearchTerm, 1500, {
      trailing: true,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.data !== this.props.data) {
      this.setState({ filteredData: this.props.data, filterText: '' });
    }
  }

  handleSearchInput = (event, data) => {
    const { value } = data;
    this.filteringData(this.props.data, value);
  };

  filteringData = (data = [], filterText = '') => {
    const cleanedFilterText = filterText.trim();
    const newFilteredData = data.filter(singleData =>
      this.props.filterFn(singleData, cleanedFilterText)
    );
    this.setState({ filteredData: newFilteredData, filterText }, () =>
      this.trackSearchTerm(cleanedFilterText)
    );
  };

  trackSearchTerm = text => {
    // console.log('track:', text);
    try {
      ReactGA.event({
        category: 'BROWSE_UNIVERSITY',
        action: 'Search',
        label: text,
      });
    } catch (err) {
      console.log('ga error:', err);
    }
  };

  render() {
    const { searchPlaceholderText, renderHeader, ...restProps } = this.props;
    const { filteredData } = this.state;
    return (
      <Box>
        <Box py={2}>
          <SearchInput
            fluid
            size="huge"
            icon="search"
            iconPosition="left"
            placeholder={searchPlaceholderText}
            onChange={this.handleSearchInput}
          />
          <Divider fitted />
          {renderHeader && (
            <Box pt={3} pb={1}>
              {renderHeader(filteredData)}
            </Box>
          )}
        </Box>
        <GridList {...restProps} data={filteredData} />
      </Box>
    );
  }
}

SearchableGridList.propTypes = {
  searchPlaceholderText: PropTypes.string,
  data: PropTypes.array.isRequired,
  filterFn: PropTypes.func,
  renderHeader: PropTypes.func,
};

SearchableGridList.defaultProps = {
  searchPlaceholderText: 'พิมพ์เพื่อค้นหา...',
  filterFn: defaultSearchFn,
};

export default SearchableGridList;
